import { Box, createStyles, Group, MantineColor, Text } from '@mantine/core';
import React from 'react';

import { DeviceStatusType } from '@portals/types';

import { getDeviceStatusColor } from '../utils/utils';

export function DeviceStatusBadge({ status }: { status: DeviceStatusType }) {
  const statusProps = getDeviceStatusColor(status);

  const { classes } = useStyles(statusProps.borderColor);

  return (
    <Group
      bg={statusProps.bg}
      className={classes.badge}
      py="xs"
      px="sm"
      spacing={4}
      noWrap
    >
      <Box bg={statusProps.indicator} className={classes.dot} />

      <Text c="gray.8" size="xs">
        {statusProps.displayName}
      </Text>
    </Group>
  );
}

const useStyles = createStyles((theme, borderColor: MantineColor) => ({
  badge: {
    borderRadius: 21,
    border: `1px solid ${theme.fn.themeColor(borderColor)}`,
  },
  dot: {
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    border: `1px solid ${theme.fn.themeColor(borderColor)}`,
  },
}));
